import React from 'react';
import { isNum } from '../format';

/**
 * Horizontal grouped bars with labels on the left and values at the tips.
 * rows: [{ label, values: [number|null, ...] }], series: [{ id, label, color }]
 */
export default function HBarList({ rows = [], series = [], valueFormat = (v) => String(v) }) {
  const max = Math.max(1, ...rows.flatMap((r) => r.values.filter(isNum)));
  return (
    <div className="le-hbar-list" role="list">
      {rows.map((row) => (
        <div key={row.label} className="le-hbar-row" role="listitem">
          <div className="le-hbar-label" title={row.label}>{row.label}</div>
          <div className="le-hbar-bars">
            {series.map((s, i) => {
              const v = row.values[i];
              const pct = isNum(v) ? Math.max(0, (v / max) * 100) : 0;
              return (
                <div key={s.id} className="le-hbar-track" title={`${s.label}: ${isNum(v) ? valueFormat(v) : '—'}`}>
                  <div className="le-hbar-fill" style={{ width: `${pct}%`, background: s.color }} />
                  <span className="le-hbar-value">{isNum(v) ? valueFormat(v) : '—'}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
